











import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { PageTitle, PageCards } from '../../core/components';
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { getDateFromDateFormatApi } from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import { NAME_ROUTES } from '../../core/utils';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Axios from 'axios';
@Component({
    components: {
        Loading,
        PageTitle,
        PageCards
    }
})
export default class SettingsPage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    cancelToken: any | null = null;
    showConfigurationDialog: boolean = false;
    pendingRequest: boolean = true;
    search: string = '';
    loaded: boolean = false;
    cards: any[] = [
        {
            name: 'Choferes',
            icon: 'mdi-account',
            description: 'Agregar, eliminar o modificar choferes.',
            url: NAME_ROUTES.DRIVERS.path,
            condition: () => this.$_checkPrivileges(PRIVILEGE_KEYS.DRIVERS, PRIVILEGE_TYPES.READ)
        },
        {
            name: 'Alarmas',
            icon: 'mdi-bell',
            description: 'Agregar, eliminar o modificar las alarmas de los vehiculos.',
            url: NAME_ROUTES.ALARMS.path,
            condition: () => this.$_checkPrivileges(PRIVILEGE_KEYS.ALARMS, PRIVILEGE_TYPES.READ)
        },
        {
            name: 'Vehículos',
            icon: 'mdi-car',
            description: 'Agregar, eliminar o modificar vehiculos.',
            url: NAME_ROUTES.VEHICLES.path,
            condition: () => this.$_checkPrivileges(PRIVILEGE_KEYS.VEHICLES, PRIVILEGE_TYPES.READ)
        },
        {
            name: 'Empresas',
            icon: 'mail',
            description: 'Agregar, eliminar o modificar Empresas',
            url: NAME_ROUTES.COMPANIES.path,
            condition: () => this.$_checkPrivileges(PRIVILEGE_KEYS.COMPANIES, PRIVILEGE_TYPES.READ)
        },
        {
            name: 'Grupos de variables',
            icon: 'mdi-clipboard-text',
            description: 'Agregar, eliminar o modificar grupos de variables.',
            url: NAME_ROUTES.VARIABLES_GROUP.path,
            condition: () => this.isSmartWay()
        },
        {
            name: 'Destinatarios',
            icon: 'mail',
            description: 'Agregar, eliminar o modificar destinatarios de uso frecuente.',
            url: NAME_ROUTES.RECIPIENTS.path,
            condition: () => this.$_checkPrivileges(PRIVILEGE_KEYS.RECIPIENTS, PRIVILEGE_TYPES.READ)
        },
        {
            name: 'Usuarios',
            icon: 'mail',
            description: 'Agregar, eliminar o modificar usuarios.',
            url: NAME_ROUTES.USERS_PAGE.path,
            condition: () => this.isSmartWay()
        },
        {
            name: 'Gestion de Reportes',
            icon: 'mail',
            description: 'Activar/Desactivar reportes',
            url: NAME_ROUTES.SETTINGS_REPORT.path,
            condition: () => this.$_checkPrivileges(PRIVILEGE_KEYS.REPORTS_PANEL, PRIVILEGE_TYPES.READ)
        }
    ];

    isSmartWay() {
        return this.$_getSmartwayMember;
    }

    cardShouldBeAvailable(card) {
        if (!card.condition) return true;
        return card.condition();
    }

    get availableCards() {
        if (!this.loaded) return [];
        return this.cards.filter(card => this.cardShouldBeAvailable(card));
    }

    mounted() {
        this.loaded = true;
    }
}
